/*
 * Точка входа SPA.
 *
 * Здесь собирается всё, что приложению нужно снаружи, и ничего сверх этого:
 * базовый адрес сервера из переменной сборщика, вёрстка и оболочка кабинета.
 *
 * Умолчания у базового адреса нет намеренно (решение `D36`): без переменной
 * приложение падает громко — на экране и в консоли — и называет её. Тихий
 * адрес самой страницы выглядит работающим на машине разработчика и
 * отказывает на выкладке.
 *
 * ПЕРЕВОРОТ блока `WEB-1.1` (спецификация §7). Было: «переключателя языка
 * здесь нет: локаль разрешается из браузера, запасная — русская». Разрешение
 * из браузера осталось, но стало **начальным значением выбора**, а не
 * единственным источником: гость выбирает язык на время вкладки, вошедший — в
 * профиль (решение `D122`). Само разрешение делает оболочка — там, где живёт
 * выбор, чтобы источников языка не стало два.
 *
 * Смена адреса доносится сюда подпиской маршрутизатора: браузерные «назад» и
 * «вперёд», глубокая ссылка и переход по переключателю приходят одним и тем же
 * событием, и каждый из них обязан перечитать то, что показывает экран.
 */

import './styles/generated/tokens.css';
import './styles/app.css';

import { createApiClient, readApiBaseUrl } from './api/client';
import { showStartupFailure, startApp } from './app';

try {
  // ПЕРЕВОРОТ блока `WEB-3.2` (спецификация §3.1). Было: точка входа
  // монтировала оболочку кабинета сама. Стало: она только зовёт выбор —
  // страница публичного отслеживания на пути ссылки, кабинет на прочих путях.
  // Выбор проверен тестами, а точка входа не участвует ни в одном, и ветка,
  // заведённая здесь, осталась бы непроверенной.
  const started = startApp(document, {
    client: createApiClient({ baseUrl: readApiBaseUrl(import.meta.env) }),
  });

  // Подписки на смену адреса здесь нет намеренно, и это правка ведущего по
  // остановке шага GREEN. Раньше она была единственным путём сигнала до
  // оболочки; теперь оболочка подписана сама, и вторая подписка означала бы
  // два обработчика на один переход: второй входит в чтение профиля, пока
  // первый ещё висит на ответе, и на каждый переход уходило бы по два
  // `GET /v1/me` и по два запроса состава фирмы. Набором это не ловится —
  // точка входа в тестах не участвует, — увидел бы только сетевой журнал.
  void started;
} catch (error) {
  // Отказ запуска показывается и бросается дальше: экран — для того, кто
  // смотрит на страницу, консоль — для того, кто её отлаживает. Перехват без
  // повторного броска превратил бы громкое падение в тихую страницу с текстом.
  showStartupFailure(document, error);

  throw error;
}
